import moment from 'moment';
import React, { FC } from 'react';
import { FormattedDate, FormattedTime } from 'react-intl';
import { AssetType } from '../../../../api/src/interfaces/shared';

interface Props {
  type: AssetType;
  showClockPrefix?: boolean;
  timestamp: Date | number | string;
}

const FormattedDateTime: FC<Props> = ({ showClockPrefix, timestamp, type }) => {
  if (timestamp === '0') {
    return <>-</>;
  }

  // If it is a share and the date is today, show minutes
  if (
    (type === 'Share' ||
      type === 'Crypto' ||
      type === 'ETF' ||
      type === 'Certificate') &&
    moment(timestamp).isSame(Date.now(), 'day')
  ) {
    return (
      <div>
        {showClockPrefix ? <span>kl </span> : undefined}
        <FormattedTime value={new Date(timestamp)} />
      </div>
    );
  }

  // Otherwise, show a date
  return <FormattedDate value={new Date(timestamp)} />;
};

export default FormattedDateTime;
